module.exports = __webpack_public_path__ + "img/step44.16b476b4.png";